import { render } from "./share-poster-template.vue?vue&type=template&id=48f9d70e&scoped=true"
import script from "./share-poster-template.vue?vue&type=script&lang=js"
export * from "./share-poster-template.vue?vue&type=script&lang=js"

import "./share-poster-template.vue?vue&type=style&index=0&id=48f9d70e&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f9d70e"]])

export default __exports__